import { a9 as fallback, a6 as attr, a7 as stringify, $ as clsx, R as slot, a0 as bind_props, P as pop, aa as sanitize_props, N as push } from "./index.js";
Promise.resolve();
function Animate($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  push();
  let delay = fallback($$props["delay"], "0s");
  $$payload.out += `<div${attr("class", `${stringify(clsx($$sanitized_props.class) + " svelte-f4k2bk")} ${stringify([
    "",
    "opacity-0"
  ].filter(Boolean).join(" "))}`)}${attr("style", `--delay: ${stringify(delay)};`)}><!---->`;
  slot($$payload, $$props, "default", {});
  $$payload.out += `<!----></div>`;
  bind_props($$props, { delay });
  pop();
}
export {
  Animate as A
};
